// extracted by mini-css-extract-plugin
module.exports = {"button":"Trigger_button__n1L87"};